
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      videoState: false
    };
  },
  methods: {
    closeVideoPlayer () {
      this.videoState = false;
      this.$refs.videoelement.pause();
    },
    openVideoPlayer () {
      this.videoState = true;
    },
    play () {
      this.$refs.videoelement.play();
    }
  }
};
